import { render } from "./SideBarComp.vue?vue&type=template&id=2a415ad3&scoped=true"
import script from "./SideBarComp.vue?vue&type=script&lang=js"
export * from "./SideBarComp.vue?vue&type=script&lang=js"

import "./SideBarComp.vue?vue&type=style&index=0&id=2a415ad3&scoped=true&lang=css"

import exportComponent from "E:\\Web\\forgexsystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a415ad3"]])

export default __exports__